import { render, staticRenderFns } from "./DuplicateGuestReview.vue?vue&type=template&id=2456d656&scoped=true"
import script from "./DuplicateGuestReview.vue?vue&type=script&lang=js"
export * from "./DuplicateGuestReview.vue?vue&type=script&lang=js"
import style0 from "./DuplicateGuestReview.vue?vue&type=style&index=0&id=2456d656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456d656",
  null
  
)

export default component.exports